const AuthCheckIcon = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
		<path
			d="M4.5 9.25L7.5 12.25L13.5 6.25"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default AuthCheckIcon;
